import React from 'react';
import './AddButton.scss';


const AddButton = ({ clickHandler }) => (
  <button type="button" className="add-button" onClick={clickHandler}>
    <img src="/img/plus.svg" className="plus-icon" alt="Add New" />
  </button>
);

export default AddButton;
